import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateLeadCustomFieldValue as UpdateLeadCustomFieldValueMutation,
    UpdateLeadCustomFieldValueVariables,
} from 'nutshell-graphql-types';

import GET_GOALS_BY_STAGE from '../../../content/sales-process-widget/graphql/queries/get-goals-by-stage.graphql';
import GET_TASKS_FOR_LEAD from '../../../content/tasks-widget/graphql/queries/get-tasks-for-lead.graphql';
import UPDATE_LEAD from '../../../shared/graphql/mutations/update-lead-custom-field-value.graphql';

export const useUpdateLeadStage = (): {
    updateLeadStage: (leadId: string, stageId: string) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateLeadStage, {loading, error}] = useMutation<
        UpdateLeadCustomFieldValueMutation,
        UpdateLeadCustomFieldValueVariables
    >(UPDATE_LEAD);

    return {
        updateLeadStage: (leadId: string, stageId: string) =>
            updateLeadStage({
                variables: {
                    lead: {
                        id: leadId,
                        stageId,
                        // We don't force stage changes to align behavior with
                        // the old lead page. This also allows us to continue
                        // sending notifications for stage changes.
                        forceStageChange: false,
                    },
                },
                refetchQueries: [
                    {query: GET_TASKS_FOR_LEAD, variables: {leadId}},
                    {query: GET_GOALS_BY_STAGE, variables: {leadId}},
                ],
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
